import React from 'react';

interface VariationProps {
  variation: string;
  default?: any;
  children?: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Variation({ variation, children }: VariationProps) {
  return <>{children}</>;
}

export const HackleVariation = Variation;
